module.exports = __webpack_public_path__ + "assets/img/store-reg-banner-06.2ddeb62f.png";